import { Container, constructor, forbiddenKeys } from './Container';
const $ = {};

$.initiate = (serviceConfig) => {
  $.container(serviceConfig);

  if (!serviceConfig.__initiated){
    for (let propertyKey in serviceConfig) {
      if (Object.prototype.hasOwnProperty.call(serviceConfig, propertyKey) && !forbiddenKeys.includes(propertyKey)) {
        if (typeof serviceConfig[propertyKey] === 'function' ||
          (serviceConfig[propertyKey].invokable && typeof serviceConfig[propertyKey].invokable === 'function')
        ){
          prepareService(serviceConfig, propertyKey);
        }else{
          serviceConfig.__subContainers[propertyKey] = $.initiate(serviceConfig[propertyKey]);
        }
      }
    }

    //Eager load by automatically accessing all the services in the container for which the load is set to EAGER.
    for (let propertyKey in serviceConfig.__config){
      if (Object.prototype.hasOwnProperty.call(serviceConfig.__config, propertyKey) && serviceConfig.__config[propertyKey].mode === $.MODE_EAGER){
        serviceConfig[propertyKey];
      }
    }

    serviceConfig.__initiated = true;
    Object.freeze(serviceConfig);
  }

  return serviceConfig;
};

$.container = (serviceConfig) => {
  if (serviceConfig instanceof Container)
    return serviceConfig;

  const reservedKeys = Object.keys(serviceConfig).filter(value => forbiddenKeys.includes(value));

  if (reservedKeys.length)
    throw new Error(`You have defined services for which the property name is reserved: ${reservedKeys.join(',')}. Please use a different name.`);

  Object.setPrototypeOf(serviceConfig, Container.prototype);
  constructor(serviceConfig);

  return serviceConfig;
};

function prepareService(serviceContainer, propertyKey) {
  let serviceConfig = serviceContainer[propertyKey];

  if (typeof serviceConfig === 'function') {
    serviceConfig = {
      invokable: serviceConfig
    }
  }

  serviceContainer.__config[propertyKey] = serviceConfig = Object.assign({
    meta: {},
    tags: [],
    invokable: null,
    type: $.TYPE_SINGLETON,
    mode: $.MODE_LAZY
  }, serviceConfig, {name : propertyKey, container : serviceContainer});

  if (!serviceConfig.invokable)
    throw new Error('required invokable property not defined for key ' + propertyKey);
  if (typeof serviceConfig.invokable !== 'function')
    throw new Error('invokable must be a function');

  const propertyConfiguration = {
    enumerable: true,
    configurable: true
  };

  switch (serviceConfig.type) {
    case $.TYPE_SINGLETON:
      switch (serviceConfig.mode) {
        case $.MODE_LAZY: case $.MODE_EAGER:
          propertyConfiguration.get = singleton(() => serviceConfig.invokable(serviceConfig));
          break;
        case $.MODE_PASSIVE:
          propertyConfiguration.get = () => singleton(() => serviceConfig.invokable(serviceConfig));
          break;
        default:
          throw new Error('Unknown service mode')
      }
      break;
    case $.TYPE_FACTORY:
      switch (serviceConfig.mode) {
        case $.MODE_LAZY:
          propertyConfiguration.get = () => serviceConfig.invokable(serviceConfig);
          break;
        case $.MODE_EAGER:
          throw new Error('Factories cannot be eager loaded');
        case $.MODE_PASSIVE:
          propertyConfiguration.get = () => () => serviceConfig.invokable(serviceConfig);
          break;
        default:
          throw new Error('Unknown service mode')
      }
      break;
    default:
      throw new Error('Unknown service type')
  }

  Object.defineProperty(serviceContainer, propertyKey, propertyConfiguration);
}

function singleton(lambda) {
  let result;

  return function () {
    return typeof result === 'undefined' ? (result = lambda()) : result;
  };
}

Object.defineProperty($, "TYPE_SINGLETON", {
  value: "singleton",
  writable: false,
  enumerable: true,
  configurable: true
});

Object.defineProperty($, "TYPE_FACTORY", {
  value: "factory",
  writable: false,
  enumerable: true,
  configurable: true
});

Object.defineProperty($, "MODE_LAZY", {
  value: "lazy",
  writable: false,
  enumerable: true,
  configurable: true
});

Object.defineProperty($, "MODE_EAGER", {
  value: "eager",
  writable: false,
  enumerable: true,
  configurable: true
});

Object.defineProperty($, "MODE_PASSIVE", {
  value: "passive",
  writable: false,
  enumerable: true,
  configurable: true
});

export default $;
